<template>
  <SAIPageWrapper :pad-x="false" :pad-y="false">
    <FinanceTabs />
    <div class="column q-gutter-y-lg q-px-md q-py-lg">
      <div>
        <SAITitle text-align="left">
          Bundle in your car running costs to save more
        </SAITitle>
        <p class="q-pt-sm">
          Novated allows you to budget in your car running costs, reducing your
          taxable income so you pay less tax. You also don’t pay for GST on your
          running costs with salary packaging (that’s 10% off on fuel!)
        </p>
      </div>

      <FrequenciesList
        :value="calculationFrequency"
        @input="$emit('update:frequency', $event)"
      />

      <BudgetRunningCosts
        :disable="true"
        class="sai-print-avoid-break-inside"
        :budgets="budgets"
        :frequency="calculationFrequency"
        @input="$emit('update:costs', $event)"
      />

      <QSeparator />

      <LeaseDescription
        :spacing-y="false"
        :lease-term="leaseTerm"
        :kms-per-year="kmsPerYear"
      />

      <BusinessUseSlider
        class="q-mt-lg"
        :value="businessUse"
        :disable="disable"
        @input="$emit('update:business-use', $event)"
      />
    </div>

    <BudgetSummary
      class="sai-print-avoid-break-inside q-mb-lg"
      :disable="disable"
      :loading="financeLoading"
      :action-label="continueLabel"
      :action-loading="applicationSaving"
      :novated="novated"
      :calculations="summaryCalculations"
      :take-home="takeHome"
      :lease-term-years="leaseTerm / 12"
      :frequency="calculationFrequency"
      :budget-comparison-view="budgetComparisonView"
      :budget-lease-type-view="budgetLeaseTypeView"
      @continue="$emit('continue')"
      @update:budget-comparison="$emit('update:budget-comparison', $event)"
      @update:budget-lease-type="$emit('update:budget-lease-type', $event)"
      @update:frequency="$emit('update:frequency', $event)"
    />

    <BudgetTerms
      class="q-px-md q-mb-lg"
      :calculator-assumptions-href="calculatorAssumptionsHref"
    />

    <QSeparator />

    <MoreInformation
      class="q-pb-lg sai-print-avoid-break-inside"
      :contact-number="contactNumber"
    />
  </SAIPageWrapper>
</template>

<script>
import { QSeparator } from 'quasar';
import { SAITitle, SAIPageWrapper } from 'ecx.saigon.ui.common';

export default {
  name: 'ApplicationBudget',
  props: {
    contactNumber: String,
    continueLabel: String,
    financeLoading: Boolean,
    disable: Boolean,
    leaseTerm: Number,
    kmsPerYear: Number,
    businessUse: undefined,
    budgetComparisonView: String,
    budgetLeaseTypeView: String,
    calculatorAssumptionsHref: String,
    calculationFrequency: {
      type: String,
      required: true
    },
    novated: {
      type: Object,
      default: () => ({})
    },
    summaryCalculations: {
      type: Array,
      default: () => []
    },
    takeHome: {
      type: Object,
      default: () => ({})
    },
    applicationSaving: Boolean,
    budgets: {
      type: Array,
      default: () => []
    }
  },
  components: {
    SAITitle,
    QSeparator,
    SAIPageWrapper,
    BudgetTerms: () => import('../../atom/budget-terms'),
    BusinessUseSlider: () => import('../../molecule/business-use-slider'),
    BudgetSummary: () => import('../../organism/budget-summary'),
    LeaseDescription: () => import('../../molecule/lease-description'),
    FrequenciesList: () => import('../../atom/frequencies-list'),
    MoreInformation: () => import('../../organism/more-information'),
    BudgetRunningCosts: () => import('../../organism/budget-running-costs'),
    FinanceTabs: () => import('../../../widgets/finance-tabs')
  }
};
</script>
